var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect, useState } from 'react';
import DataTableBody from './DataTableBody';
import DataTableHeader from './DataTableHeader';
import ColumnResizer from './ColumnResizer';
import { DataTableContext, useDataTableContext } from './DataTableContext';
import { Scroller } from '../';
import { CustomCheckbox } from '../CustomCheckbox';
import reactWindowFixer from './reactWindowFixer';
import DataTableFooter from './DataTableFooter';
;
export var DataTable = function (_a) {
    var id = _a.id, data = _a.data, getData = _a.getData, loading = _a.loading, columns = _a.columns, itemHeight = _a.itemHeight, _b = _a.checkboxConfig, checkboxConfig = _b === void 0 ? { enable: false } : _b, totalData = _a.totalData, dontFormatRow = _a.dontFormatRow, handleSort = _a.handleSort, _c = _a.resetOrder, resetOrder = _c === void 0 ? 'desc' : _c, _d = _a.resetOrderBy, resetOrderBy = _d === void 0 ? '' : _d, multiLevelStyleSupport = _a.multiLevelStyleSupport, multiLevelSortSupport = _a.multiLevelSortSupport;
    var _e = useState('desc'), order = _e[0], setOrder = _e[1];
    var _f = useState(resetOrderBy || ''), orderBy = _f[0], setOrderBy = _f[1];
    var _g = useState(false), callInProgress = _g[0], setCallInProgress = _g[1];
    var _h = useState(0), contentUpdated = _h[0], setContentUpdated = _h[1];
    var _j = useState(0), resetRequired = _j[0], setResetRequired = _j[1];
    var dataTableCtx = useDataTableContext(checkboxConfig);
    useEffect(function () {
        handleSort && handleSort({ order: order, orderBy: orderBy });
    }, [order, orderBy]);
    useEffect(function () {
        if (resetOrder) {
            setOrder(resetOrder);
        }
        if (resetOrderBy) {
            setOrderBy(resetOrderBy);
        }
    }, [resetOrder, resetOrderBy]);
    var containerId = id || 'data-grid-container';
    var updateSelectAll = function (length) {
        var select = (data.length === length && data.length !== 0) ? true : false;
        dataTableCtx.setSelectAll(select);
    };
    /**
     * constructor, enbaling column resizer only once
     */
    useEffect(function () {
        ColumnResizer(containerId, function () {
            setContentUpdated(contentUpdated + 1);
        });
    }, []);
    /**
     * Re-enabling the column resizers on changing the column configuratiuon
     */
    useEffect(function () {
        ColumnResizer(containerId, function () {
            setContentUpdated(contentUpdated + 1);
        });
        // resizes scroller after updating the column configuration
        setContentUpdated(contentUpdated + 1);
    }, [columns]);
    /**
     * Sets the call in progress to false on receiving data
     */
    useEffect(function () {
        setCallInProgress(false);
        setContentUpdated(contentUpdated + 1);
        updateSelectAll(dataTableCtx.selectedRowIds.length);
        // resetting scroll positions in case if data is empty
        if (!data.length) {
            setResetRequired(resetRequired + 1);
        }
    }, [data]);
    /**
     * populates back the selected row ids to the DataTable's parent componnet
     */
    useEffect(function () {
        if (checkboxConfig.enable) {
            checkboxConfig.setSelectedRowIds(dataTableCtx.selectedRowIds);
        }
        updateSelectAll(dataTableCtx.selectedRowIds.length);
    }, [dataTableCtx.selectedRowIds]);
    /**
     * force populates selected row ids from DataTable's parent componnet
     */
    useEffect(function () {
        if (checkboxConfig.enable) {
            dataTableCtx.setSelectedRowIds(checkboxConfig.selectedRowIds);
        }
    }, [checkboxConfig.forceUpdate]);
    var scrollDetection = function (e) {
        //const grid = document.getElementById(containerId+"_grid");
        //scrollDetection broken because of react window implementation 
        // refactor this below code
        var grid = document.querySelector(".data-grid-container");
        if (grid) {
            if (grid.offsetHeight + grid.scrollTop >= grid.scrollHeight) {
                if (getData && !callInProgress) {
                    setCallInProgress(true);
                    getData();
                }
            }
        }
    };
    useEffect(function () {
        //const grid = document.getElementById(containerId+"_grid");
        var grid = document.querySelector(".data-grid-container");
        grid === null || grid === void 0 ? void 0 : grid.addEventListener('scroll', scrollDetection);
        // updates data-grid-row width as equal to data-grid-head
        reactWindowFixer();
        return function () {
            grid === null || grid === void 0 ? void 0 : grid.removeEventListener('scroll', scrollDetection);
        };
    });
    var getCheckboxColumnConfig = function () {
        if (checkboxConfig.enable) {
            var rowIds_1 = data.map(function (r) { return r[checkboxConfig.uniqueId]; });
            return {
                id: checkboxConfig.uniqueId,
                width: checkboxConfig.width || 53,
                style: { width: checkboxConfig.width + 'px' || '53px' },
                label: React.createElement(CustomCheckbox, { grey: true, checked: dataTableCtx.selectAll, onChange: function (e) { return dataTableCtx.handleSelectAll(e, rowIds_1); } }),
                fixed: true,
                tooltip: false,
                resizable: false,
                headerTooltip: false,
                align: 'center',
                render: function (value, row, index) { return (React.createElement(CustomCheckbox, { grey: true, checked: dataTableCtx.selectedRowIds.includes(value), onChange: function (e) { return dataTableCtx.handleRowSelect(value); } })); }
            };
        }
        else {
            return false;
        }
    };
    var checkboxColumnConfig = getCheckboxColumnConfig();
    var filteredColumns = columns.filter(function (c) { return typeof c !== 'undefined'; });
    return (React.createElement(DataTableContext.Provider, { value: dataTableCtx },
        React.createElement("div", { id: containerId },
            React.createElement(Scroller, { id: "campaigns-scroller", className: "custom-scroll", resetRequired: resetRequired, contentUpdated: contentUpdated, primarySelector: ".data-grid-container", childrenSelectors: [
                    '.data-grid-head-container',
                    '.data-grid-container',
                    '.data-grid-footer-container'
                ], itemHeight: itemHeight, rowsLength: data === null || data === void 0 ? void 0 : data.length },
                React.createElement(DataTableHeader, { data: data, order: order, setOrder: setOrder, orderBy: orderBy, setOrderBy: setOrderBy, checkboxConfig: checkboxConfig, columns: checkboxColumnConfig ? __spreadArray([checkboxColumnConfig], filteredColumns) : filteredColumns }),
                React.createElement(DataTableBody, { id: containerId, data: data, order: order, orderBy: orderBy, loading: loading, itemHeight: itemHeight, checkboxConfig: checkboxConfig, columns: checkboxColumnConfig ? __spreadArray([checkboxColumnConfig], filteredColumns) : filteredColumns, dontFormatRow: dontFormatRow, multiLevelStyleSupport: multiLevelStyleSupport, multiLevelSortSupport: multiLevelSortSupport }),
                React.createElement(DataTableFooter, { id: containerId, data: data, columns: checkboxColumnConfig ? __spreadArray([checkboxColumnConfig], filteredColumns) : filteredColumns, totalData: totalData, loading: loading })))));
};
export * from './types';
